import { useState, useEffect,useRef } from 'react';
import { HomeIcon, UserIcon, CogIcon, ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAppContext } from '../../context/AppContext';
import Header from '../../components/Header';
import AdminSidebar from './Pages/AdminSidebar';

import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

    import { ToastContainer,Flip } from 'react-toastify';
    import 'react-toastify/dist/ReactToastify.css';

const Dashboard = () => {
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mouseMoveTimeoutRef = useRef(null);

const { authState, user, login ,logout} = useAppContext();


useEffect(() => {
if(user.role !== '9'){
logout()
}
},[])


console.log(user)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
   // resetInactivityTimer('toggled sidebar');
  };

  const navItems = [
    { name: 'Home', icon: HomeIcon, href: '#' },
    { name: 'Profile', icon: UserIcon, href: '#' },
    { name: 'Settings', icon: CogIcon, href: '#' },
  ];

  useEffect(() => {
    const handleInteraction = (event) => {
      if (event.type === 'mousemove') {
        if (mouseMoveTimeoutRef.current) {
          clearTimeout(mouseMoveTimeoutRef.current);
        }
        mouseMoveTimeoutRef.current = setTimeout(() => {
        }, 5000); // Debounce mousemove by 5 seconds
      } else {
        const action = event.type === 'click' ? 'clicked' : event.type === 'keypress' ? 'typed' : 'interacted';
       // resetInactivityTimer(action);
      }
    };

    window.addEventListener('click', handleInteraction);
    window.addEventListener('keypress', handleInteraction);

    return () => {
      window.removeEventListener('click', handleInteraction);
      window.removeEventListener('keypress', handleInteraction);
      if (mouseMoveTimeoutRef.current) {
        clearTimeout(mouseMoveTimeoutRef.current);
      }
    };
  }, []);

  return (
    <>
    {/* <ToastContainer position="top-center" theme="dark" autoClose="2000" hideProgressBar={true} transition={Flip} /> */}
    <Toaster 
     position="top-center"
     toastOptions={{
          style: {
           width: '500px', // Adjust max-width as needed
            padding: '20px',    // Increase padding for more space
            fontSize: '18px',   // Increase font size
 duration: 5000,
          },
        }}
  />

    <div className="min-h-screen bg-gray-100 flex">
    <AdminSidebar isCollapsed={isSidebarOpen} toggleSidebar={toggleSidebar}/>
      <div className="flex-1 flex flex-col">
        <Header />
        <main className={`${isSidebarOpen ? 'ml-16' : 'ml-40'} mt-20 p-2 h-[calc(100vh-4rem)] transition-all duration-300`}>
         <Outlet />
              </main>
      </div>
    </div>
    </>
  );
};

export default Dashboard;